module.exports = __webpack_public_path__ + "static/media/7671.a0e49c24.png";